/**
 * Backorder display web component.
 * Listens for variant:change and shows/hides backorder text per variant.
 */
class BackorderDisplay extends HTMLElement {
  constructor() {
    super();
    this._variantChangeHandler = this._handleVariantChange.bind(this);
  }

  connectedCallback() {
    this._backorderTextElement = this.querySelector("[data-backorder-text]");
    if (!this._backorderTextElement) return;

    const backorderDataEl = document.getElementById("backorder");
    if (!backorderDataEl) return;

    this._backorderVariants = JSON.parse(backorderDataEl.innerText);
    this._backorderLabel = document.querySelector("[data-backorder-label]");

    document.addEventListener("variant:change", this._variantChangeHandler);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:change", this._variantChangeHandler);
  }

  _handleVariantChange(event) {
    const variantId = event.detail.variant.id;
    const text = this._backorderVariants.find((t) => t.id == variantId)?.text;

    if (text) {
      this._backorderTextElement.innerText = text;
      this._backorderTextElement.hidden = false;
      if (this._backorderLabel) this._backorderLabel.hidden = false;
    } else {
      this._backorderTextElement.hidden = true;
      if (this._backorderLabel) this._backorderLabel.hidden = true;
    }

    const selectedOptions = event.detail.variant.options;
    const optionSelectors = document.querySelectorAll("[data-option-selector]");

    optionSelectors.forEach((selector, index) => {
      const position = index;
      const buttons = selector.querySelectorAll('button[role="option"]');

      buttons.forEach((button) => {
        const optionValue = button.getAttribute("value");
        const matchingVariant = this._backorderVariants.find((variant) => {
          if (variant.options[position] !== optionValue) return false;
          return variant.options.every((opt, i) => {
            if (i === position) return true;
            return opt === selectedOptions[i];
          });
        });

        const backorderSpan = button.querySelector(".text-error");
        if (matchingVariant && matchingVariant.text && backorderSpan) {
          backorderSpan.innerText = window.themeVariables?.strings?.backorder ?? "Backorder";
          backorderSpan.hidden = false;
        } else if (backorderSpan) {
          backorderSpan.hidden = true;
        }
      });
    });
  }
}

customElements.define("backorder-display", BackorderDisplay);
